import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const RentalChecklist = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default RentalChecklist;
